import React, { useEffect, useRef, useState } from "react";
import { TreeView, TreeItem } from "@mui/lab";
import Checkbox from "@mui/material/Checkbox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, Stack } from "@mui/material";
import { getWingList } from "../../Services/Payments";

const bfsSearch = (graph, targetId) => {
  const queue = [...graph];

  while (queue.length > 0) {
    const currNode = queue.shift();
    if (currNode.id === targetId) {
      return currNode;
    }
    if (currNode.children) {
      queue.push(...currNode.children);
    }
  }
  return []; // Target node not found
};

const TreeviewCheckbox = ({
  data: _data,
  value = { p: [], w: [], f: [] },
  onChange = () => {},
  selectedCheckboxes = [],
  onSelectCheckbox = () => {},
  handleFetchChildren = () => {},
  isChildFetch = false,
}) => {
  const data = {
    id: "p_1",
    label: "Project 1",
    children: [
      {
        id: "p_1-w_1",
        label: "Wing 1",
        children: [
          {
            id: "p_1-w_1-f_1",
            label: "Floor 1-1",
          },
          {
            id: "p_1-w_1-f_2",
            label: "Floor 1-2",
          },
          {
            id: "p_1-w_1-f_3",
            label: "Floor 1-3",
          },
        ],
      },
      {
        id: "p_1-w_2",
        label: "Wing 2",
        children: [
          {
            id: "p_1-w_2-f_1",
            label: "Floor 2-1",
          },
        ],
      },
    ],
  };
  // const [selected, setSelected] = useState([]);
  const [treeViewData, setTreeViewData] = useState([]);
  const ref = useRef(null);

  useEffect(() => {
    setTreeViewData(_data);
  }, [_data]);

  function getAllIds(node, idList = []) {
    idList.push(node.id);
    if (node.children) {
      node.children.forEach((child) => getAllIds(child, idList));
    }
    return idList;
  }
  // Get IDs of all children from specific node
  const getAllChild = (id) => {
    return getAllIds(bfsSearch(_data, id));
  };

  // Get all father IDs from specific node
  const getAllFathers = (id, list = []) => {
    const node = bfsSearch(_data, id);
    if (node.parent) {
      list.push(node.parent);

      return getAllFathers(node.parent, list);
    }
    return list;
  };

  function isAllChildrenChecked(node, list) {
    const allChild = getAllChild(node.id);
    const nodeIdIndex = allChild.indexOf(node.id);
    allChild.splice(nodeIdIndex, 1);

    return allChild.every((nodeId) =>
      selectedCheckboxes.concat(list).includes(nodeId)
    );
  }

  const fetchData = async (nodeId) => {
    let cloneProject = [];
    if (
      isChildFetch &&
      nodeId.includes("p=") &&
      !nodeId.includes("w=") &&
      !nodeId.includes("f=")
    ) {
      const selectedParent = _data.find((val) => val.id === nodeId);
      if (selectedParent?.children[0] === "") {
        const data = await getWingList(nodeId);

        const finalPayload = [..._data];
        const index = finalPayload.findIndex((i) => i.id === nodeId);
        finalPayload.splice(index, 1, data[0]);
        cloneProject.push(...finalPayload);
      } else {
        cloneProject.push(...treeViewData);
      }
    }

    return cloneProject;
  };

  // const handleCheckboxChange = async (event, nodeIds) => {
  //   let data = [];

  //   event.stopPropagation();
  //   if (selectedCheckboxes.includes(nodeIds)) {
  //     const test = (isChildFetch ? cloneProject : _data)?.filter(
  //       (val) => val?.id === nodeIds
  //     );

  //     if (nodeIds?.includes("w=")) {
  //       const payload = [];
  //       selectedCheckboxes.forEach(
  //         (val) => !val.includes(nodeIds) && payload.push(val)
  //       );
  //       const finalPayload = payload.filter((val) => val !== nodeIds);
  //       data = [...finalPayload];
  //       onSelectCheckbox(data);
  //     } else if (
  //       nodeIds.includes("p=") &&
  //       !nodeIds?.includes("w=") &&
  //       !nodeIds?.includes("f=")
  //     ) {
  //       const children = [];
  //       test.forEach((val) => {
  //         if (val?.children?.length > 0) {
  //           val?.children.forEach((v) => {
  //             children.push(v.id);
  //             if (v?.children?.length > 0) {
  //               v.children.forEach((s) => children.push(s.id));
  //             }
  //           });
  //         }
  //       });

  //       const payload = [];
  //       selectedCheckboxes.forEach(
  //         (val) => !children.includes(val) && payload.push(val)
  //       );

  //       const finalPayload = payload.filter((val) => val !== nodeIds);
  //       data = [...finalPayload];
  //       // data = [...selectedCheckboxes.filter((n) => n !== nodeIds)];

  //       onSelectCheckbox(data);
  //     }
  //   } else {
  //     const test = (isChildFetch ? cloneProject : _data)?.filter(
  //       (val) => val?.id === nodeIds
  //     );
  //     const pay1 = _data?.filter((data) => nodeIds.includes(data.id));
  //     if (nodeIds.includes("w=")) {
  //       const pay2 = [];
  //       const pay3 = [];

  //       pay1.forEach((val) => {
  //         pay2.push(...val?.children);
  //       });
  //       pay2.forEach((val) => pay3.push(...val?.children));
  //       const finalPayload = [...pay1, ...pay2, ...pay3];
  //       const children = [];
  //       finalPayload.forEach((val) => {
  //         if (val.id?.includes(nodeIds)) {
  //           children.push(val?.id);
  //         }
  //       });
  //       data = [...selectedCheckboxes, ...children, nodeIds];
  //       onSelectCheckbox(data);
  //     } else if (
  //       nodeIds.includes("p=") &&
  //       !nodeIds?.includes("w=") &&
  //       !nodeIds?.includes("f=")
  //     ) {
  //       const children = [];
  //       test.forEach((val) => {
  //         if (val?.children?.length > 0) {
  //           val?.children.forEach((v) => {
  //             children.push(v.id);
  //             if (v?.children?.length > 0) {
  //               v.children.forEach((s) => children.push(s.id));
  //             }
  //           });
  //         }
  //       });
  //       data = [...selectedCheckboxes, ...children, nodeIds];
  //       // setSelected(data);
  //       onSelectCheckbox(data);
  //     }
  //   }
  //   onChange(getParsedData(data));
  // };

  const handleNodeSelect = (event, nodeId) => {
    event.stopPropagation();
    let data = [];
    const allChild = getAllChild(nodeId);
    const fathers = getAllFathers(nodeId);
    if (_data?.length > 0) {
      if (selectedCheckboxes.includes(nodeId)) {
        // Need to de-check
        const payload = [...selectedCheckboxes];
        data = payload.filter((id) => !allChild.concat(fathers).includes(id));
      } else {
        // Need to check
        const ToBeChecked = allChild;
        for (let i = 0; i < fathers.length; ++i) {
          if (isAllChildrenChecked(bfsSearch(_data, fathers[i]), ToBeChecked)) {
            ToBeChecked.push(fathers[i]);
          }
        }
        const payload = [...selectedCheckboxes];
        data = [...payload].concat(ToBeChecked);
      }
      const payload = [];
      data.forEach((val) => {
        if (val?.includes("&w=") && val?.includes("&f=")) {
          payload.push(val?.substring(0, val?.indexOf("&f=")));
          payload.push(val?.substring(0, val?.indexOf("&w=")));
        }

        if (val?.includes("&w=") && !val?.includes("&f=")) {
          payload.push(val?.substring(0, val?.indexOf("&w=")));
        }
        payload.push(val);
      });
      onSelectCheckbox([...new Set(payload)]);
      onChange(getParsedData(data));
    }
  };

  const handleExpandClick = (event) => {
    // prevent the click event from propagating to the checkbox
    event.stopPropagation();
  };

  const renderTree = (nodes) => (
    <TreeItem
      key={nodes.id}
      nodeId={nodes.id}
      onClick={handleExpandClick}
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <Checkbox
            checked={selectedCheckboxes.indexOf(nodes.id) !== -1}
            tabIndex={-1}
            disableRipple
            onClick={(event) => handleNodeSelect(event, nodes.id)}
          />
          <span>{nodes?.label?.toUpperCase()}</span>
        </Stack>
      }
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );
  return (
    <Box
      sx={{
        "& *": {
          fontSize: "2rem !important",
        },
        "& span + span": {
          fontSize: "1.5rem !important",
        },
      }}
    >
      {treeViewData.map((t) => (
        <TreeView
          key={t.id}
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          onNodeToggle={(e) => {
            t.children[0] === "" && handleFetchChildren(t.id);
          }}
          // onNodeSelect={handleCheckboxChange}
        >
          {renderTree(t)}
        </TreeView>
      ))}
    </Box>
  );
  // else return <>Loading...</>;
};

export default TreeviewCheckbox;

function parseProjectStr(str) {
  let obj = {};
  // let arr = str.split("&").map((kv) => kv.split("="));
  let arr = str?.split("&").map((kv) => kv.split("=")) || [];
  arr.forEach(([key, value]) => {
    obj[key] = value;
  });
  return obj;
}

function getParsedData(data) {
  let result = { p: [], w: [], f: [] };

  data.forEach((str) => {
    const { p, w, f } = parseProjectStr(str);
    p && result.p.push(p);
    w && result.w.push(w);
    f && result.f.push(f);
  });

  const payload = {
    p: [...new Set(result.p)],
    w: [...new Set(result.w)],
    f: [...new Set(result.f)],
  };

  return payload;
}
